import { Component, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IOperation, IOperationListColumnResponse, OperationsListRequest, IEditRowField } from '../airport-interfaces';
import { AirportService } from '../airport.service';
import { ScenarioService } from '../../scenario-activities/scenario.service';
import { UserInfoService } from '../../shared/user-info.service';
import { UserSession } from '../../shared/user-session';
import { Button } from 'primeng/primeng';
import { Column } from 'primeng/primeng';
import { TemplateLoader } from 'primeng/primeng';
import { TemplateWrapper } from 'primeng/primeng';
import { PrimeTemplate } from 'primeng/primeng';
import { ColumnBodyTemplateLoader } from 'primeng/primeng';
import { Footer } from 'primeng/primeng';
import * as _ from 'lodash';

import {SystemControl} from '../../shared/system-control';
import {SystemControlElem} from '../../shared/system-control-elem';
import { SystemControlService} from '../../shared/system-control.service';

@Component({
    selector: 'operation-grid',
    template: require('./operation-grid.component.html'),
    styles: [require('../../styles/faa_styles.css')],
    //encapsulation: ViewEncapsulation.None,
    directives: [Button, Column, TemplateLoader, TemplateWrapper, PrimeTemplate, ColumnBodyTemplateLoader, Footer]
})

export class OperationGridComponent implements OnInit, OnDestroy{
    @Input() operation: IOperation;

    //so everything we do in here will need to check this, we only want to do stuff if we are the selected one
    @Input() selected: boolean;
    @Input() locId: string;
    @Input() airportName: string;
    @Input() displayAll: boolean;

    //will need an array of results objects
    //and a columns object to create the rows
    results: any[]
    selectedRow: any;
    columns: IOperationListColumnResponse[];
    editableColumns: IOperationListColumnResponse[];
    errorMessage: string;

    editRow: any[];
    displayDialog: boolean = false;
    isAAT: IOperationListColumnResponse[];
    canEdit: boolean = false;
    dialogHeader = "Detail";

    //displayAll: boolean = false;
    displayAllText: string = "View Previous Years";
    systemControlElem: SystemControlElem;

    //might need the routes
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService,
                private _userInfoService: UserInfoService, 
                private User: UserSession,
                private request: OperationsListRequest,
                private _systemControlService:SystemControlService) 
    {}

    ngOnInit(): void{
        if(this.selected){

            this.request.tableName = this.operation.tableName;
            this.request.scenarioId = this.User.getSession().scenarioId;
            this.request.locId = this.locId;
            this.request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;


             this._airportService.getOperationsColumns(this.request)
                    .subscribe(
                        columns => {
                            this.columns = columns;
                            this.editableColumns = _.filter(this.columns, function(column) { return !column.calculated; });
                            _.find(columns, function(column){column.fieldName ==='AAT'?column.isAAT=1:column.isAAT=0;});
                            
                        },
                        error => this.errorMessage = <any>error,
                        () => {
                        }
                    );

            this.getResults();
        }
    }

    //may not need this
    ngOnDestroy(){}


    getResults(){

       this._systemControlService.getSystemControl()
            .subscribe(
            systemControlElem => this.systemControlElem = systemControlElem,
            error => this.errorMessage = <any>error,
            ()=>{
                this._airportService.getOperationsList(this.request)
                            .subscribe(
                                results => {
                                    this.results = results;
                                    this.results.map(result => {
                                        result.scenarioDisplay = result.SCENARIO == 0 ? "" : "*";
                                    });

                                    if(!this.displayAll)
                                    {
                                        this.results = this.results.filter(results => { return results.AYEAR > (this.systemControlElem.ffcYear - 4) });
                                    }

                                    this.results.sort((n1,n2) => {
                                        if (n1.AYEAR > n2.AYEAR) {
                                            return 1;
                                        }

                                        if (n1.AYEAR < n2.AYEAR) {
                                            return -1;
                                        }

                                        return 0;
                                    });
                                    
                                    this.setDisplayAllText(this.displayAll);

                                },
                                error => this.errorMessage = <any>error
                            );
            });
    }

    onRowSelect(event: any) {
        //lets make this a view if they are not the scenario owner or admin
        //need to get the scenario of the row
         
        if(this.User.getSession().isAdmin){
            this.dialogHeader = "Edit";
            this.canEdit = true;
            this.editRow = this.cloneRow(event.data);
            this.displayDialog = true;
        }
        else{
            this._userInfoService.isScenarioOwner(this.User.getSession()['id'], event.data.SCENARIO).subscribe(
                success => {
                    if(success.isOwner){
                        this.dialogHeader = "Edit";
                        this.canEdit = true;
                        this.editRow = this.cloneRow(event.data);
                        this.displayDialog = true;
                    }
                    else{
                        this.dialogHeader = "Detail";
                        this.canEdit = false;
                        this.editRow = this.cloneRow(event.data);
                        this.displayDialog = true;

                    }   
                },
                error => this.errorMessage = <any>error
            );
        }
    }

    
    cloneRow(dataToClone: any): any {
        let editableColumnCounter: number = 0;
        let cloneListCounter: number = 0;

        let cloneList: IEditRowField[] = [];


        for(let prop in dataToClone) {

            let clone: IEditRowField = {value: "", fieldName: "", displayName: "", readOnly: false, display: true};

            if( _.find(this.editableColumns, function(column: any) {return column.fieldName === prop})){
                
                clone.value = dataToClone[prop];
                clone.fieldName = prop;
                clone.displayName = this.editableColumns[editableColumnCounter].displayName;
                clone.readOnly = false;
            
                cloneList[cloneListCounter] = clone;

                editableColumnCounter++;
                cloneListCounter++;
            }
            // else if(_.find(this.columns, function(column: any) {return column.graphName === prop && column.calculated})){
            //     clone.value = dataToClone[prop];
            //     clone.fieldName = prop;
            //     clone.displayName = _.find(this.columns, function(column: any) {return column.graphName === prop && column.calculated}).displayName;
            //     clone.readOnly = true;

            //     cloneList[cloneListCounter] = clone;

            //     cloneListCounter++;
                
            // }
            else if (prop === "AYEAR")
            {
                //really only want year in here
                clone.value = dataToClone[prop];
                clone.fieldName = prop;
                clone.displayName = "Year";
                clone.readOnly = true;

                cloneList[cloneListCounter] = clone;

                cloneListCounter++;
                
            }
            else if (prop === "SCENARIO")
            {
                clone.value = dataToClone[prop];
                clone.fieldName = prop;
                clone.display = false;
                clone.readOnly = true;

                cloneList[cloneListCounter] = clone;

                cloneListCounter++;
                
            }
        }
        return cloneList;
    }

    addButtonClicked(){        
    
        let params = {
            locId: this.locId,
            tableName: this.operation.tableName,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-add-year`, params]);
    }

    columnClick(event: any) {
        let params = {
            locId: this.locId,
            fieldName: event.field,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-reforcast/${this.operation.tableName}`, params]);
    }

    save(){
        let params = {
            tableName: this.operation.tableName,
            locId: this.locId,
            editRow: this.editRow,

        }

        this._airportService.updateOperations(params)
            .subscribe(
                response => {
                    if(response.responseStatus == "success"){
                        this.getResults();  
                        this.displayDialog = false;
                    }
                    else if(response.responseStatus == "error"){
                        this.displayDialog = false;
                        this.errorMessage = "An error occured while trying to update the row.";
                        console.error(response.responseMessage);
                    }
                },
                error => {
                    this.displayDialog = false;
                    this.errorMessage = "An error occured while trying to update the facility.";
                    console.error(error);
                }
            );
    }

    displayAllYears(){

        this.displayAll = !this.displayAll;

        this.setDisplayAllText(this.displayAll);

        this.getResults();
    }

    setDisplayAllText(flag: boolean){
        if(flag){
            this.displayAllText = "Hide Previous Years";
        }else{    
            this.displayAllText = "View Previous Years";
        }
    }
}




/** WEBPACK FOOTER **
 ** ./app/airports/Operations-lists/operation-grid.component.ts
 **/